module.exports = __webpack_public_path__ + "img/nuts.772758b3.jpg";